module.exports = __webpack_public_path__ + "img/pic_usa_05.f931d913.jpg";